// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageTextSlice_wrapper__a52a2","left":"ImageTextSlice_left__44161","right":"ImageTextSlice_right__7a563"};